/**
 * @generated SignedSource<<79e0c1698b5ebb5994517b2ca3140aa8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNoteUploadImageLayoutInput = {
  scale: number;
  translateX: number;
  translateY: number;
};
export type useSaveNoteImageMutation$variables = {
  imageId: string;
  layout: WidgetNoteUploadImageLayoutInput;
  noteId: string;
  pageId: string;
};
export type useSaveNoteImageMutation$data = {
  readonly note: {
    readonly page: {
      readonly setImage: {
        readonly id: string;
        readonly image: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"PageSettingsDeleteButton_image">;
        } | null;
        readonly imageScale: number | null;
        readonly imageTranslateX: number | null;
        readonly imageTranslateY: number | null;
        readonly " $fragmentSpreads": FragmentRefs<"WidgetNotePageBackground_widgetNotePage">;
      };
    };
  };
};
export type useSaveNoteImageMutation$rawResponse = {
  readonly note: {
    readonly page: {
      readonly setImage: {
        readonly backgroundColor: string | null;
        readonly containImage: boolean | null;
        readonly id: string;
        readonly image: {
          readonly id: string;
          readonly largeImage: {
            readonly height: number;
            readonly id: string;
            readonly url: string;
            readonly width: number;
          } | null;
          readonly smallImage: {
            readonly id: string;
            readonly url: string;
          } | null;
        } | null;
        readonly imageScale: number | null;
        readonly imageTranslateX: number | null;
        readonly imageTranslateY: number | null;
        readonly remoteImageURL: string | null;
      };
    };
  };
};
export type useSaveNoteImageMutation = {
  rawResponse: useSaveNoteImageMutation$rawResponse;
  response: useSaveNoteImageMutation$data;
  variables: useSaveNoteImageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "imageId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "layout"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "noteId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "pageId"
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "imageId",
    "variableName": "imageId"
  },
  {
    "kind": "Variable",
    "name": "layout",
    "variableName": "layout"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageScale",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageTranslateX",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageTranslateY",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSaveNoteImageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "NoteMutation",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "NotePageMutation",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "WidgetNotePage",
                "kind": "LinkedField",
                "name": "setImage",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PageSettingsDeleteButton_image"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WidgetNotePageBackground_widgetNotePage"
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSaveNoteImageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "NoteMutation",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "NotePageMutation",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "WidgetNotePage",
                "kind": "LinkedField",
                "name": "setImage",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": "smallImage",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "minHeight",
                            "value": 100
                          },
                          {
                            "kind": "Literal",
                            "name": "minWidth",
                            "value": 100
                          }
                        ],
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "size",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": "size(minHeight:100,minWidth:100)"
                      },
                      {
                        "alias": "largeImage",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "minHeight",
                            "value": 1080
                          },
                          {
                            "kind": "Literal",
                            "name": "minWidth",
                            "value": 1080
                          }
                        ],
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "size",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "height",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "width",
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": "size(minHeight:1080,minWidth:1080)"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "backgroundColor",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "remoteImageURL",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "containImage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "86a799a400c584962d0eddf0c2023a4e",
    "id": null,
    "metadata": {},
    "name": "useSaveNoteImageMutation",
    "operationKind": "mutation",
    "text": "mutation useSaveNoteImageMutation(\n  $noteId: ID!\n  $pageId: ID!\n  $layout: WidgetNoteUploadImageLayoutInput!\n  $imageId: ID!\n) {\n  note(id: $noteId) {\n    page(id: $pageId) {\n      setImage(layout: $layout, imageId: $imageId) {\n        id\n        image {\n          id\n          ...PageSettingsDeleteButton_image\n        }\n        ...WidgetNotePageBackground_widgetNotePage\n        imageScale\n        imageTranslateX\n        imageTranslateY\n      }\n    }\n  }\n}\n\nfragment PageSettingsDeleteButton_image on Image {\n  id\n  ...PageSettingsSmallImage_image\n}\n\nfragment PageSettingsSmallImage_image on Image {\n  id\n  smallImage: size(minWidth: 100, minHeight: 100) {\n    url\n    id\n  }\n}\n\nfragment WidgetNotePageBackground_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  image {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  imageScale\n  imageTranslateX\n  imageTranslateY\n  remoteImageURL\n  containImage\n}\n"
  }
};
})();

(node as any).hash = "6230cad6a74104b8ab62ce3e90f12b22";

export default node;
